import toast from 'react-hot-toast';

export const ADD_TO_CART = "ADD_TO_CART";
export const DECREMENT_QTY = "DECREMENT_QTY";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REMOVE_ALL_FROM_CART = "REMOVE_ALL_FROM_CART";

//add to cart
export const addToCart = (
  item,
  quantityCount,
  selectedProductColor,
  selectedProductSize
) => {
  return dispatch => {
    toast.success("Added To Cart");
    dispatch({
      type: ADD_TO_CART,
      payload: {
        ...item,
        quantity: quantityCount,
        selectedProductColor: selectedProductColor
          ? selectedProductColor
          : item.selectedProductColor
            ? item.selectedProductColor
            : null,
        selectedProductSize: selectedProductSize
          ? selectedProductSize
          : item.selectedProductSize
            ? item.selectedProductSize
            : null
      }
    });
  };
};
//decrement from cart
export const decrementQty = (item) => {
  return dispatch => {
    // react-hot-toast has no toast.warn; the call threw and the decrement never reached the reducer.
    toast("Item Decremented From Cart");
    dispatch({ type: DECREMENT_QTY, payload: item });
  };
};
//remove from cart
export const removeFromCart = (item) => {
  return dispatch => {
    toast.error("Removed From Cart");
    dispatch({ type: REMOVE_FROM_CART, payload: item });
  };
};
// empty the cart after a placed order, without the "removed" toast of removeAllFromCart
export const clearCart = () => {
  return dispatch => {
    dispatch({ type: REMOVE_ALL_FROM_CART });
  };
};
//remove all from cart
export const removeAllFromCart = () => {
  return dispatch => {
    toast.error("Removed All From Cart");
    dispatch({ type: REMOVE_ALL_FROM_CART });
  };
};

// get stock of cart item
export const cartItemStock = (item, color, size) => {
  if (item.stock) {
    return item.stock;
  } else {
    return item.variation
    .filter(single => single.color === color)[0]
    .size.filter(single => single.name === size)[0].stock;
  }
};
